import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.rag.pipeline');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-rag-pipeline',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.rag.pipeline/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
}

.rag-page {
  min-width: 320px;
  background: radial-gradient(circle at 92% 0, rgba(59, 130, 246, 0.08), transparent 30rem), radial-gradient(circle at 8% 42%, rgba(14, 165, 233, 0.04), transparent 24rem), #f8fafc;
}

.pipeline-nav {
  max-height: calc(100vh - 185px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.pipeline-nav::-webkit-scrollbar {
  width: 5px;
}

.pipeline-nav::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}

.pdf-sheet {
  border-radius: 2px;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.12);
}

pre {
  margin: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
}

table th,
table td {
  vertical-align: middle;
}

button:focus-visible,
select:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

@media (max-width: 1279px) {
  .pipeline-nav {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(175px, 1fr);
    max-height: none;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .pipeline-connector {
    display: none;
  }
}
@media (max-width: 639px) {
  .pdf-sheet {
    width: 100%;
    max-width: 300px;
  }
}`],
})
export class PageRagPipelineComponent implements OnInit {
    public loading: boolean = true;
    public error: string = '';
    public mode: string = 'actual';
    public sourcePath: string = 'llm_paper_selected';
    public steps: any[] = [];
    public documents: any[] = [];
    public stageResults: any = {};
    public baselineStageResults: any = {};
    public modelCatalog: any = {};
    public runtimeTopology: any = {
        embedding: {},
        vector_db: {},
        docling: {},
        vlm: {}
    };
    public selectedModelIds: any = {};
    public stageRuns: any = {};
    public runningStageId: string = '';
    public pipelineRunning: boolean = false;
    public summary: any = {
        document_count: 0,
        page_count: 0,
        size_bytes: 0,
        completed_steps: 0,
        total_steps: 10
    };
    public selectedStageId: string = 'parsing';
    public selectedDocumentId: string = '';
    public selectedPage: number = 1;
    public selectedChunkId: string = 'chunk-002';
    public selectedStructureBlockOrder: number = 1;
    public structureVlmRunning: boolean = false;
    public structureVlmError: string = '';
    public structureCropLoading: boolean = false;
    public structureCropError: string = '';
    public pageThumbnailLoading: boolean = false;
    public pageThumbnailError: string = '';
    public fullPageTextLoading: boolean = false;
    public fullPageTextError: string = '';
    private pageThumbnailRequestId: number = 0;
    private pageTextRequestId: number = 0;
    private structureCropRequestId: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadOverview();
    }

    public async loadOverview() {
        this.loading = true;
        this.error = '';
        await this.service.render();
        try {
            const response: any = await this.readWithRetry('overview');
            if (!response || response.code !== 200) {
                this.error = this.errorMessage(response);
            } else {
                this.mode = response.data.mode || 'actual';
                this.sourcePath = response.data.source_path || 'llm_paper_selected';
                this.steps = response.data.steps || [];
                this.documents = response.data.documents || [];
                this.baselineStageResults = this.clone(response.data.stage_results || {});
                this.stageResults = this.clone(this.baselineStageResults);
                this.modelCatalog = response.data.model_catalog || {};
                this.runtimeTopology = response.data.runtime_topology || {};
                this.initializeModelSelections();
                this.summary = Object.assign({}, this.summary, response.data.summary || {});
                if (this.documents.length) this.selectedDocumentId = this.documents[0].id;
                this.applyPipelineStatus(response.data.pipeline_status || {});
            }
        } catch (requestError) {
            this.error = '화면 데이터를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';
        }
        this.loading = false;
        await this.service.render();
        if (!this.error && this.documents.length) {
            await this.loadFullPageText();
            await this.loadPageThumbnail();
        }
    }

    public async selectStage(stage: any) {
        if (!stage || !stage.id) return;
        this.selectedStageId = stage.id;
        await this.service.render();
        if (stage.id === 'structure') await this.loadStructureCrop();
    }

    public async documentChanged() {
        this.selectedPage = 1;
        this.selectedChunkId = 'chunk-002';
        this.selectedStructureBlockOrder = 1;
        this.structureVlmError = '';
        this.structureCropError = '';
        this.structureCropLoading = false;
        this.structureCropRequestId += 1;
        this.fullPageTextError = '';
        this.fullPageTextLoading = false;
        this.pageTextRequestId += 1;
        this.error = '';
        this.stageResults = this.clone(this.baselineStageResults);
        this.stageRuns = {};
        this.setStepStatuses({});
        await this.service.render();
        try {
            const response: any = await wiz.call('status', {
                document_id: this.selectedDocumentId
            });
            if (response && response.code === 200) {
                this.applyPipelineStatus(response.data.pipeline_status || {});
            } else {
                this.error = this.errorMessage(response);
            }
        } catch (requestError) {
            this.error = '선택한 문서의 실행 상태를 불러오지 못했습니다.';
        }
        await this.service.render();
        await this.loadFullPageText();
        await this.loadPageThumbnail();
    }

    public async selectPage(page: number) {
        this.selectedPage = page;
        this.fullPageTextError = '';
        this.fullPageTextLoading = false;
        this.pageTextRequestId += 1;
        await this.service.render();
        await this.loadFullPageText();
        await this.loadPageThumbnail();
    }

    public async selectChunk(chunk: any) {
        if (!chunk) return;
        this.selectedChunkId = chunk.id;
        await this.service.render();
    }

    public async selectStructureBlock(block: any) {
        if (!block || !block.order) return;
        this.selectedStructureBlockOrder = Number(block.order);
        this.structureVlmError = '';
        this.structureCropError = '';
        await this.service.render();
        await this.loadStructureCrop();
    }

    public isVisualStructureBlock(block?: any) {
        const requested = block || this.currentStructureBlock();
        return requested && (requested.type === 'figure' || requested.type === 'table');
    }

    public async analyzeCurrentVisual() {
        const block = this.currentStructureBlock();
        const vlm = this.runtimeTopology.vlm || {};
        if (!this.isVisualStructureBlock(block) || !vlm.available || this.structureVlmRunning) {
            return;
        }
        this.structureVlmRunning = true;
        this.structureVlmError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('analyze_visual', {
                document_id: this.selectedDocumentId,
                block_order: block.order,
                model_id: vlm.id
            });
            const payload = response && response.code === 200
                ? response.data.visual_analysis
                : null;
            if (!payload || !payload.block) {
                this.structureVlmError = this.errorMessage(response);
            } else {
                const target = this.structureBlocks().find((item: any) => {
                    return Number(item.order) === Number(payload.block.order);
                });
                if (target) {
                    Object.assign(target, payload.block);
                    this.structureCropError = '';
                }
                (payload.invalidated_stages || []).forEach((stageId: string) => {
                    delete this.stageResults[stageId];
                    delete this.stageRuns[stageId];
                    const stage = this.steps.find((item: any) => item.id === stageId);
                    if (stage) stage.status = 'pending';
                });
                this.summary.completed_steps = this.steps.filter((item: any) => {
                    return item.status === 'complete';
                }).length;
            }
        } catch (requestError) {
            this.structureVlmError = '원격 VLM 분석 요청에 실패했습니다.';
        }
        this.structureVlmRunning = false;
        await this.service.render();
    }

    public modelGroup(stageId?: string) {
        return this.modelCatalog[stageId || this.selectedStageId] || null;
    }

    public modelOptions(stageId?: string) {
        const group = this.modelGroup(stageId);
        return group && Array.isArray(group.options) ? group.options : [];
    }

    public selectedModels(stageId?: string) {
        const requestedStageId = stageId || this.selectedStageId;
        const selectedIds = this.selectedModelIds[requestedStageId] || [];
        return this.modelOptions(requestedStageId).filter((option: any) => {
            return selectedIds.indexOf(option.id) >= 0;
        });
    }

    public selectedPrimaryModel(stageId?: string) {
        return this.selectedModels(stageId)[0] || {};
    }

    public selectedModelSummary(stageId?: string) {
        const labels = this.selectedModels(stageId).map((option: any) => option.label);
        return labels.length ? labels.join(' + ') : '모델을 선택해주세요.';
    }

    public isModelSelected(modelId: string, stageId?: string) {
        const requestedStageId = stageId || this.selectedStageId;
        return (this.selectedModelIds[requestedStageId] || []).indexOf(modelId) >= 0;
    }

    public async toggleModel(model: any) {
        const group = this.modelGroup();
        if (!group || !model || !model.available || group.selection_mode !== 'multiple') return;
        const selected = (this.selectedModelIds[this.selectedStageId] || []).slice();
        const index = selected.indexOf(model.id);
        if (index >= 0) {
            if (selected.length === 1) return;
            selected.splice(index, 1);
        } else {
            selected.push(model.id);
        }
        this.selectedModelIds[this.selectedStageId] = selected;
        this.markRunStale(this.selectedStageId);
        await this.service.render();
    }

    public async selectSingleModel(modelId: string) {
        if (!modelId) return;
        const option = this.modelOptions().find((item: any) => item.id === modelId);
        if (!option || !option.available) return;
        this.selectedModelIds[this.selectedStageId] = [modelId];
        this.markRunStale(this.selectedStageId);
        await this.service.render();
    }

    public modelOptionClass(model: any) {
        if (!model.available) {
            return 'cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400 opacity-70';
        }
        if (this.isModelSelected(model.id)) {
            return 'border-blue-300 bg-blue-50 text-blue-800 ring-1 ring-blue-200';
        }
        return 'border-slate-200 bg-white text-slate-600 hover:border-blue-200 hover:bg-slate-50';
    }

    public canRunCurrentStage() {
        return !!this.modelGroup()
            && this.selectedModels().length > 0
            && this.selectedModels().every((model: any) => !!model.available)
            && !this.runningStageId
            && !this.pipelineRunning;
    }

    public async runCurrentStage() {
        if (!this.canRunCurrentStage()) return;
        await this.executeStage(this.selectedStageId);
    }

    public async runPipeline() {
        if (this.pipelineRunning || this.runningStageId) return;
        const runnableStages = this.steps.filter((stage: any) => !!this.modelCatalog[stage.id]);
        if (!runnableStages.length) return;
        this.pipelineRunning = true;
        await this.service.render();
        for (const stage of runnableStages) {
            const succeeded = await this.executeStage(stage.id);
            if (!succeeded) break;
        }
        this.pipelineRunning = false;
        this.runningStageId = '';
        await this.service.render();
    }

    public stageRun(stageId?: string) {
        return this.stageRuns[stageId || this.selectedStageId] || null;
    }

    public stageRunLabel(stageId?: string) {
        const requestedStageId = stageId || this.selectedStageId;
        if (this.runningStageId === requestedStageId) return '실행 중';
        const run = this.stageRun(requestedStageId);
        if (!run) return '실행 전';
        if (run.status === 'complete') return '실행 완료';
        if (run.status === 'stale') return '재실행 필요';
        if (run.status === 'error') return '실행 실패';
        return '실행 전';
    }

    public stageRunBadgeClass(stageId?: string) {
        const requestedStageId = stageId || this.selectedStageId;
        if (this.runningStageId === requestedStageId) return 'bg-blue-100 text-blue-700';
        const run = this.stageRun(requestedStageId);
        if (run && run.status === 'complete') return 'bg-emerald-100 text-emerald-700';
        if (run && run.status === 'error') return 'bg-rose-100 text-rose-700';
        if (run && run.status === 'stale') return 'bg-amber-100 text-amber-700';
        return 'bg-slate-100 text-slate-500';
    }

    public currentStage() {
        return this.steps.find((stage: any) => stage.id === this.selectedStageId) || {
            order: 0,
            label: '파이프라인',
            description: '',
            status: 'pending',
            input_label: '-',
            output_label: '-'
        };
    }

    public selectedDocument() {
        return this.documents.find((document: any) => document.id === this.selectedDocumentId)
            || this.documents[0]
            || {
                id: '-',
                filename: '문서 없음',
                title: '문서를 선택해주세요.',
                author: '-',
                published_year: '-',
                page_count: 0,
                size_label: '-',
                mime_type: '-',
                extension: '-',
                excerpt: '표시할 추출 텍스트가 없습니다.'
            };
    }

    public result(stageId: string) {
        return this.stageResults[stageId] || {};
    }

    public currentChunk() {
        const chunks = (this.result('chunking').chunks || []);
        return chunks.find((chunk: any) => chunk.id === this.selectedChunkId)
            || chunks[0]
            || {};
    }

    public currentPageResult() {
        const pages = this.result('parsing').pages_preview || [];
        return pages.find((page: any) => page.page === this.selectedPage)
            || pages[0]
            || { excerpt: this.result('parsing').excerpt || '' };
    }

    public displayedPageText() {
        const page = this.currentPageResult();
        if (typeof page.full_text === 'string') {
            return page.full_text;
        }
        return page.excerpt || '';
    }

    public fullPageTextLoaded() {
        const page = this.currentPageResult();
        return typeof page.full_text === 'string';
    }

    private async loadFullPageText() {
        const page = this.currentPageResult();
        const pageNumber = Number(page.page || this.selectedPage || 0);
        const parsingRun = this.stageRuns.parsing || {};
        if (
            parsingRun.status !== 'complete'
            || !this.selectedDocumentId
            || !pageNumber
            || typeof page.full_text === 'string'
            || this.fullPageTextLoading
        ) return;
        const documentId = this.selectedDocumentId;
        const requestId = ++this.pageTextRequestId;
        this.fullPageTextLoading = true;
        this.fullPageTextError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('page_text', {
                document_id: documentId,
                page: pageNumber
            });
            if (requestId !== this.pageTextRequestId) return;
            const payload = response && response.code === 200
                ? response.data.page_text
                : null;
            if (!payload || typeof payload.text !== 'string') {
                this.fullPageTextError = this.errorMessage(response);
                return;
            }
            const target = (this.result('parsing').pages_preview || []).find((item: any) => {
                return Number(item.page) === pageNumber;
            });
            if (target && this.selectedDocumentId === documentId) {
                target.full_text = payload.text;
            }
        } catch (requestError) {
            if (requestId === this.pageTextRequestId) {
                this.fullPageTextError = '전체 원문을 불러오지 못했습니다.';
            }
        } finally {
            if (requestId === this.pageTextRequestId) {
                this.fullPageTextLoading = false;
                await this.service.render();
            }
        }
    }

    public structureBlocks() {
        const blocks = this.result('structure').blocks;
        return Array.isArray(blocks) ? blocks : [];
    }

    public currentStructureBlock() {
        const blocks = this.structureBlocks();
        return blocks.find((block: any) => {
            return Number(block.order) === this.selectedStructureBlockOrder;
        }) || blocks[0] || {};
    }

    public structureBlockPreview(block: any) {
        if (!block) return '';
        return block.caption || block.content || '';
    }

    public hasStructuredTable(block?: any) {
        const requested = block || this.currentStructureBlock();
        const table = requested && requested.table_data;
        return !!table
            && Array.isArray(table.headers)
            && Array.isArray(table.data)
            && table.headers.length > 0;
    }

    public structureBlockButtonClass(block: any) {
        return Number(block && block.order) === Number(this.currentStructureBlock().order)
            ? 'border-blue-200 bg-blue-50 ring-1 ring-blue-100'
            : 'border-transparent bg-white hover:border-slate-200 hover:bg-slate-50';
    }

    public parsingPageCount() {
        const pages = this.result('parsing').pages_preview;
        return Array.isArray(pages) ? pages.length : 0;
    }

    public parsingVlmResults() {
        const results = this.result('parsing').vlm_results;
        return Array.isArray(results) ? results : [];
    }

    public completionPercent() {
        const total = Number(this.summary.total_steps || this.steps.length || 1);
        const complete = Number(this.summary.completed_steps || 0);
        return Math.round((complete / total) * 100);
    }

    public formatBytes(bytes: any) {
        const value = Number(bytes || 0);
        if (value >= 1024 * 1024) return (value / (1024 * 1024)).toFixed(1) + ' MB';
        if (value >= 1024) return Math.round(value / 1024) + ' KB';
        return value + ' B';
    }

    public statusLabel(status: string) {
        if (status === 'complete') return '완료';
        if (status === 'active') return '처리 중';
        return '미완료';
    }

    public statusBadgeClass(status: string) {
        if (status === 'complete') return 'bg-emerald-50 text-emerald-700 ring-emerald-600/20';
        if (status === 'active') return 'bg-blue-50 text-blue-700 ring-blue-600/20';
        return 'bg-slate-100 text-slate-500 ring-slate-500/10';
    }

    public stageButtonClass(stage: any) {
        if (stage.id === this.selectedStageId) {
            return 'border-blue-200 bg-blue-50 shadow-sm';
        }
        return 'border-transparent bg-white hover:border-slate-200 hover:bg-slate-50';
    }

    public stageNumberClass(stage: any) {
        if (stage.status === 'complete') return 'bg-emerald-500 text-white';
        if (stage.status === 'active') return 'bg-blue-600 text-white ring-4 ring-blue-100';
        return 'bg-slate-100 text-slate-400 ring-1 ring-inset ring-slate-200';
    }

    public stageLineClass(stage: any) {
        return stage.status === 'complete' ? 'bg-emerald-300' : 'bg-slate-200';
    }

    public stageContextLabel(status: string) {
        if (status === 'complete') return '실행 결과';
        if (status === 'active') return '현재 처리 단계';
        return '실행 전 결과 예시';
    }

    public blockClass(type: string) {
        if (type === 'title') return 'bg-violet-50 text-violet-700';
        if (type === 'figure') return 'bg-amber-50 text-amber-700';
        if (type === 'table') return 'bg-emerald-50 text-emerald-700';
        if (type === 'caption') return 'bg-fuchsia-50 text-fuchsia-700';
        if (type === 'heading') return 'bg-blue-50 text-blue-700';
        if (type === 'abstract') return 'bg-cyan-50 text-cyan-700';
        return 'bg-slate-100 text-slate-600';
    }

    public metadataValue(field: any) {
        if (field && Array.isArray(field.value)) return field.value.join(', ');
        return field.value;
    }

    public formatVector(values: any[]) {
        if (!Array.isArray(values)) return '[]';
        return '[ ' + values.map((value: number) => Number(value).toFixed(4)).join(', ') + ', … ]';
    }

    public detectionJson() {
        const document = this.selectedDocument();
        const detection = this.result('detection');
        return JSON.stringify({
            document_id: document.id,
            type: String(detection.type || 'pdf').toLowerCase(),
            mime_type: document.mime_type,
            confidence: Number(detection.confidence || 0) / 100,
            encrypted: false,
            method: detection.method || ''
        }, null, 2);
    }

    public indexedLabel(indexed: boolean) {
        return indexed ? 'Indexed' : 'Stored only';
    }

    public trackById(index: number, item: any) {
        return item && (item.id || item.chunk_id || item.field) || index;
    }

    public errorMessage(response: any) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.message) return response.message;
        return 'RAG 파이프라인 화면 데이터를 불러오지 못했습니다.';
    }

    private initializeModelSelections() {
        Object.keys(this.modelCatalog || {}).forEach((stageId: string) => {
            const group = this.modelCatalog[stageId] || {};
            const defaults = Array.isArray(group.default_ids) ? group.default_ids.slice() : [];
            const availableIds = (group.options || [])
                .filter((option: any) => !!option.available)
                .map((option: any) => option.id);
            const validDefaults = defaults.filter((modelId: string) => availableIds.indexOf(modelId) >= 0);
            if (!this.selectedModelIds[stageId] || !this.selectedModelIds[stageId].length) {
                this.selectedModelIds[stageId] = validDefaults.length
                    ? validDefaults
                    : availableIds.slice(0, 1);
            }
        });
    }

    private markRunStale(stageId: string) {
        if (!this.stageRuns[stageId]) return;
        this.stageRuns[stageId] = {
            status: 'stale',
            message: '모델 구성이 변경되었습니다. 다시 실행해주세요.'
        };
    }

    private async executeStage(stageId: string) {
        const modelIds = (this.selectedModelIds[stageId] || []).slice();
        if (!modelIds.length) return false;
        const stage = this.steps.find((item: any) => item.id === stageId);
        const previousStatus = stage ? stage.status : 'pending';
        this.runningStageId = stageId;
        if (stage) stage.status = 'active';
        this.stageRuns[stageId] = { status: 'running' };
        await this.service.render();

        let response: any = null;
        try {
            response = await wiz.call('run_stage', {
                stage_id: stageId,
                document_id: this.selectedDocumentId,
                model_ids: JSON.stringify(modelIds)
            });
            if (response && response.code === 202 && response.data.job) {
                response = await this.waitForJob(response.data.job);
            }
        } catch (requestError) {
            response = null;
        }

        if (response && response.code === 200) {
            const run = response.data.run || { status: 'complete' };
            this.stageRuns[stageId] = run;
            if (stage) stage.status = 'complete';
            if (run.result) this.stageResults[stageId] = run.result;
            const stageIndex = this.steps.findIndex((item: any) => item.id === stageId);
            this.steps.slice(stageIndex + 1).forEach((item: any) => {
                item.status = 'pending';
                delete this.stageRuns[item.id];
            });
            this.summary.completed_steps = this.steps.filter((item: any) => {
                return item.status === 'complete';
            }).length;
            this.error = '';
        } else {
            if (stage) stage.status = previousStatus;
            this.stageRuns[stageId] = {
                status: 'error',
                message: this.errorMessage(response)
            };
            this.error = this.errorMessage(response);
        }
        this.runningStageId = '';
        await this.service.render();
        if (response && response.code === 200 && stageId === 'parsing') {
            this.selectedPage = 1;
            this.fullPageTextError = '';
            this.fullPageTextLoading = false;
            this.pageTextRequestId += 1;
            await this.loadFullPageText();
            await this.loadPageThumbnail();
        }
        if (response && response.code === 200 && stageId === 'structure') {
            this.selectedStructureBlockOrder = 1;
            await this.service.render();
            await this.loadStructureCrop();
        }
        return !!(response && response.code === 200);
    }

    private async readWithRetry(name: 'overview' | 'job_status', params: any = {}) {
        // Retry only reads: a lost run_stage response must never start a second job.
        for (let attempt = 0; attempt < 3; attempt += 1) {
            try {
                const response: any = await wiz.call(name, params);
                // WIZ returns the failed jQuery XHR (status 0) on network errors.
                if (response && response.status !== 0) return response;
            } catch (requestError) {
                if (requestError && (requestError as any).status > 0) throw requestError;
            }
            if (attempt < 2) {
                await new Promise((resolve) => setTimeout(resolve, 500 * (attempt + 1)));
            }
        }
        return {
            code: 0,
            data: {
                message: name === 'job_status'
                    ? '네트워크 연결 문제로 실행 상태를 확인하지 못했습니다. 서버 작업은 계속 진행될 수 있으므로 연결 복구 후 상태를 확인해주세요.'
                    : '네트워크 연결 문제로 화면 데이터를 불러오지 못했습니다. 연결 상태를 확인한 뒤 다시 시도해주세요.'
            }
        };
    }

    private async waitForJob(initialJob: any) {
        let job = initialJob || {};
        for (let attempt = 0; attempt < 600; attempt += 1) {
            this.stageRuns[job.stage_id || this.runningStageId] = {
                status: 'running',
                message: job.message || 'Docling 모델을 실행하고 있습니다.'
            };
            await this.service.render();
            await new Promise((resolve) => setTimeout(resolve, 2000));
            const response: any = await this.readWithRetry('job_status', { job_id: job.job_id });
            if (!response || response.code !== 200) return response;
            job = response.data.job || {};
            if (job.status === 'complete') {
                return { code: 200, data: { run: job.run } };
            }
            if (job.status === 'error') {
                return { code: 500, data: { message: job.message } };
            }
        }
        return { code: 504, data: { message: 'Docling 실행 제한 시간을 초과했습니다.' } };
    }

    private applyPipelineStatus(status: any) {
        this.stageRuns = status.runs || {};
        this.restoreSavedModelSelections(this.stageRuns);
        this.stageResults = Object.assign(
            this.clone(this.baselineStageResults),
            status.stage_results || {}
        );
        this.setStepStatuses(this.stageRuns);
        this.summary.completed_steps = Number(status.completed_steps || 0);
    }

    private restoreSavedModelSelections(runs: any) {
        Object.keys(runs || {}).forEach((stageId: string) => {
            const run = runs[stageId] || {};
            const savedIds = Array.isArray(run.model_ids) ? run.model_ids : [];
            const availableIds = this.modelOptions(stageId)
                .filter((option: any) => !!option.available)
                .map((option: any) => option.id);
            const validIds = savedIds.filter((modelId: string) => {
                return availableIds.indexOf(modelId) >= 0;
            });
            if (validIds.length === savedIds.length && validIds.length) {
                this.selectedModelIds[stageId] = validIds;
            }
        });
    }

    private setStepStatuses(runs: any) {
        (this.steps || []).forEach((stage: any) => {
            stage.status = runs[stage.id] && runs[stage.id].status === 'complete'
                ? 'complete'
                : 'pending';
        });
    }

    private async loadPageThumbnail() {
        const document = this.selectedDocument();
        const page = this.currentPageResult();
        const pageNumber = Number(page.page || this.selectedPage || 0);
        if (!document.id || document.id === '-' || !pageNumber || page.thumbnail) return;

        const requestId = ++this.pageThumbnailRequestId;
        this.pageThumbnailLoading = true;
        this.pageThumbnailError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('page_thumbnail', {
                document_id: document.id,
                page: pageNumber
            });
            if (requestId !== this.pageThumbnailRequestId) return;
            const payload = response && response.code === 200
                ? response.data.page_thumbnail
                : null;
            if (!payload || !payload.thumbnail) {
                this.pageThumbnailError = this.errorMessage(response);
                return;
            }
            const target = (this.result('parsing').pages_preview || []).find((item: any) => {
                return Number(item.page) === pageNumber;
            });
            if (target && this.selectedDocumentId === document.id) {
                target.thumbnail = payload.thumbnail;
            }
        } catch (requestError) {
            if (requestId === this.pageThumbnailRequestId) {
                this.pageThumbnailError = '원본 PDF 페이지 이미지를 불러오지 못했습니다.';
            }
        } finally {
            if (requestId === this.pageThumbnailRequestId) {
                this.pageThumbnailLoading = false;
                await this.service.render();
            }
        }
    }

    private async loadStructureCrop() {
        const document = this.selectedDocument();
        const block = this.currentStructureBlock();
        if (!document.id || document.id === '-' || !this.isVisualStructureBlock(block)) {
            this.structureCropLoading = false;
            return;
        }
        if (block.crop_thumbnail) return;

        const requestId = ++this.structureCropRequestId;
        const blockOrder = Number(block.order || 0);
        this.structureCropLoading = true;
        this.structureCropError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('visual_crop', {
                document_id: document.id,
                block_order: blockOrder
            });
            if (requestId !== this.structureCropRequestId) return;
            const payload = response && response.code === 200
                ? response.data.visual_crop
                : null;
            if (!payload || !payload.crop_thumbnail) {
                this.structureCropError = this.errorMessage(response);
                return;
            }
            const target = this.structureBlocks().find((item: any) => {
                return Number(item.order) === blockOrder;
            });
            if (target && this.selectedDocumentId === document.id) {
                target.crop_thumbnail = payload.crop_thumbnail;
                target.bbox = payload.bbox || target.bbox;
            }
        } catch (requestError) {
            if (requestId === this.structureCropRequestId) {
                this.structureCropError = '원본 Figure/Table crop을 불러오지 못했습니다.';
            }
        } finally {
            if (requestId === this.structureCropRequestId) {
                this.structureCropLoading = false;
                await this.service.render();
            }
        }
    }

    private clone(value: any) {
        return JSON.parse(JSON.stringify(value || {}));
    }
}

export default PageRagPipelineComponent;